module.exports = __webpack_public_path__ + "img/no-feed.b0adc326.svg";